import { render } from "./Target.vue?vue&type=template&id=1acd379f"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Target.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1acd379f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1acd379f', __exports__)) {
    api.reload('1acd379f', __exports__)
  }
  
  module.hot.accept("./Target.vue?vue&type=template&id=1acd379f", () => {
    api.rerender('1acd379f', render)
  })

}


export default __exports__